import { useAuth } from 'context/AuthContext';
import { actionLog } from 'services/actionlog.service';
import { findGestor } from 'services/profile.service';

import { podeTrocarGestor } from '../equipe-regras';
import ModalDeBusca, { PessoaEncontrada } from './ModalDeBusca';
import { GestorEncontrado, pessoaDoGestor } from './pessoa-da-busca';

export interface ModalAlterarGestorProps {
  isOpen: boolean;
  /** Liderado cujo gestor muda. */
  liderado: { chave: string; nome: string } | null;
  onFechar: () => void;
  /** `change_manager` registrado: a página fecha o modal, avisa e recarrega a lista. */
  onConcluido: () => void;
}

const FORA_DA_ALCADA =
  'Essa solicitação deve ser realizada via Fale com a Gestão de Pessoas > Plataforma > Pessoas > Minha visão > Fale com a Gestão de Pessoas > Abrir demanda > Joga Junto';

/** Indica outro gestor para um liderado (`change_manager`), com a regra de `cod_etapa` do líder. */
export default function ModalAlterarGestor({ isOpen, liderado, onFechar, onConcluido }: ModalAlterarGestorProps) {
  const { user, userInfo } = useAuth();

  async function buscar(termo: string) {
    if (!user?._id) return [];
    const encontrados: GestorEncontrado[] = await findGestor(user?._id, termo);
    return (Array.isArray(encontrados) ? encontrados : []).filter(gestor => gestor._id !== liderado?.chave).map(pessoaDoGestor);
  }

  function bloqueio(pessoa: PessoaEncontrada<GestorEncontrado>) {
    return podeTrocarGestor(userInfo?.cod_etapa, pessoa.dados.cod_etapa) ? null : FORA_DA_ALCADA;
  }

  async function confirmar(pessoa: PessoaEncontrada<GestorEncontrado>) {
    await actionLog('me', 'change_manager', { player: liderado?.chave, newGestor: pessoa.dados.extra?.id });
    onConcluido();
  }

  return (
    <ModalDeBusca
      isOpen={isOpen && !!liderado}
      titulo={`Alterar gestor de ${liderado?.nome ?? ''}`}
      texto="Indique o novo líder responsável pela apreciação das Realizações Destaque deste funcionário na Plataforma Joga Junto BB."
      rotuloDoCampo="Novo gestor"
      placeholder="Digite o nome ou a chave do gestor"
      aviso="A troca de líder serve apenas para viabilizar a apreciação pelo novo gestor. Não indique novo líder em ausências temporárias como férias, folgas ou licença de até 15 dias."
      rotuloDoConfirmar="Alterar gestor"
      buscar={buscar}
      bloqueio={bloqueio}
      confirmar={confirmar}
      onFechar={onFechar}
    />
  );
}
